var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TituloPagina"}},[_c('div',{staticClass:"container no-margin no-padding"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s10 m6 l6"},[_c('h4',{staticClass:"header"},[_vm._v(_vm._s(_vm.titulo))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319b8e7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TituloPagina.vue
// module id = null
// module chunks = 